// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { CollateralAgreementRequest as CollateralAgreementRequestV2 } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Collateral';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

export const useCollateralAgreementRequestsV2: () => UseQueryResult<
  TemplateContract<CollateralAgreementRequestV2>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data || '';
  return useQueryWithOptions({
    queryKey: ['queryCollateralAgreementRequestsV2', operator],
    enabled: !!operator,
    queryFn: async (_, options) => {
      return ledgerApi.queryCollateralAgreementRequestsV2(options, operator);
    },
  });
};
